module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 152.feb47c86.png";